export default __webpack_public_path__ + "static/media/video-1603553202.1f716729.mp4";